/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";

import { useLocation, useNavigate } from "react-router-dom";
import {
  Button,
  DatePicker,
  Form,
  Input,
  Modal,
  Table,
  Typography,
  message,
} from "antd";
import { Card, Col, Divider, Flex, Row, Space, Drawer, Segmented } from "antd";

import OptionService from "../../../service/ERP/Options.service";
import GoodsReceiptService from "../../../service/ERP/GoodsReceipt.service";
import { SaveFilled, SearchOutlined } from "@ant-design/icons";
import ModalSupplier from "../../../components/modal/ERP/supplier/ModalSupplier";
import ModalCustomers from "../../../components/modal/ERP/customers/ModalCustomers";
import ModalGrItems from "../../../components/modal/ERP/gr-items/ModalGrItems";

import {
  goodsreceiptForm,
  columnsParametersEditable,
  componentsEditable,
} from "./model";
import { ModalItems } from "../../../components/modal/ERP/itemsbyPO/modal-items";
import dayjs from "dayjs";
import { delay } from "../../../utils/util";
import { ButtonBack } from "../../../components/button";

import { RiDeleteBin5Line } from "react-icons/ri";
import { LuPackageSearch } from "react-icons/lu";
import { LuPrinter } from "react-icons/lu";
import { EditOutlined } from "@ant-design/icons";
import {
  TbSquareRoundedCheck,
  TbSquareRoundedChevronsLeft,
} from "react-icons/tb";

import ManageFormExpiryDate from "../../../components/drawer/good-receipt/MyManageFormExpiryDate";
import ActionGroup, { PrintButton } from "../../../components/action-group/ActionGroup";

const opservice = OptionService();
const grservice = GoodsReceiptService();

const gotoFrom = "/ERP/goods-receipt";
const dateFormat = "DD/MM/YYYY";
const drawerBodyStyle = { paddingBlock: 8, paddingLeft: 18, paddingRight: 8 };

function GoodsReceiptManage() {
  const navigate = useNavigate();
  const location = useLocation();

  const { config } = location.state || { config: null };
  const [form] = Form.useForm();

  /** Modal handle */
  const [openSupplier, setOpenSupplier] = useState(false);
  const [openProduct, setOpenProduct] = useState(false);
  /* รับของจากลูกค้า (ไม่มีใบสั่งซื้อ) */
  const [openCustomer, setOpenCustomer] = useState(false);
  const [openFreeItems, setOpenFreeItems] = useState(false);
  const [sourceType, setSourceType] = useState("PO");
  const isFromCustomer = sourceType === "CUSTOMER";

  /** GoodsReceipt state */
  const [poCode, setPoCode] = useState(null);

  /** Detail Data State */
  const [listDetail, setListDetail] = useState([]);

  const [formDetail, setFormDetail] = useState(goodsreceiptForm);

  const [unitOption, setUnitOption] = useState([]);

  const [formPO, setFormPO] = useState([]);
  const [openExpiryDate, setOpenExpiryDate] = useState(false);

  const cardStyle = {
    backgroundColor: "#f0f0f0",
    height: "calc(100% - (25.4px + 1rem))",
  };

  useEffect(() => {
    const initial = async () => {
      if (config?.action !== "create") {
        const res = await grservice
          .get(config?.code)
          .catch((error) => message.error("get GoodsReceipt data fail."));
        const { header, detail } = res.data;
        const { grcode, grdate } = header;
        // alert('grcode')
        setFormDetail(header);
        setListDetail(detail);
        setPoCode(grcode);
        setSourceType(header?.source_type === "CUSTOMER" ? "CUSTOMER" : "PO");
        form.setFieldsValue({
          ...header,
          grdate: dayjs(grdate),
          /* วันที่เอกสารผู้จำหน่าย เว้นว่างได้ */
          inv_date: header.inv_date ? dayjs(header.inv_date) : null,
        });

        // setTimeout( () => {  handleCalculatePrice(head?.valid_price_until, head?.dated_price_until) }, 200);
        // handleChoosedSupplier(head);
      } else {
        const { data: code } = (
          await grservice.code().catch((e) => {
            message.error("get GoodsReceipt code fail.");
          })
        ).data;
        setPoCode(code);
        form.setFieldValue("vat", 7);
        const ininteial_value = {
          ...formDetail,
          grcode: code,
          grdate: dayjs(new Date()),
        };
        setFormDetail(ininteial_value);
        form.setFieldsValue(ininteial_value);
      }
      const [unitOprionRes] = await Promise.all([
        opservice.optionsUnit({ p: "unit-option" }),
      ]);
      // console.log(unitOprionRes.data.data)
      setUnitOption(unitOprionRes.data.data);
    };

    initial();
    return () => {};
  }, []);

  useEffect(() => {
    if (listDetail) handleSummaryPrice();
  }, [listDetail]);

  const handleSummaryPrice = () => {
    const newData = [...listDetail];

    const total_price = newData.reduce(
      (a, v) =>
        (a +=
          Number(v.qty || 0) * Number(v?.price || 0) -
          Number(v?.discount || 0)),
      0
    );
    const vat = form.getFieldValue("vat");
    const grand_total_price =
      total_price + (total_price * form.getFieldValue("vat")) / 100;

    setFormDetail(() => ({
      ...formDetail,
      total_price,
      vat,
      grand_total_price,
    }));
    // console.log(formDetail)
  };

  const handleCalculatePrice = (day, date) => {
    const newDateAfterAdding = dayjs(date || new Date()).add(
      Number(day),
      "day"
    );
    const nDateFormet = newDateAfterAdding.format("YYYY-MM-DD");

    setFormDetail((state) => ({ ...state, dated_price_until: nDateFormet }));
    form.setFieldValue("dated_price_until", nDateFormet);
  };

  const handleQuotDate = (e) => {
    const { valid_price_until } = form.getFieldsValue();
    if (!!valid_price_until && !!e) {
      handleCalculatePrice(valid_price_until || 0, e || new Date());
    }
  };

  /** Function modal handle */
  const handleChoosedSupplier = (val) => {
    // console.log(val)
    const fvalue = form.getFieldsValue();
    const addr = [
      !!val?.idno ? `${val.idno} ` : "",
      !!val?.road ? `${val?.road} ` : "",
      !!val?.subdistrict ? `${val.subdistrict} ` : "",
      !!val?.district ? `${val.district} ` : "",
      !!val?.province ? `${val.province} ` : "",
      !!val?.zipcode ? `${val.zipcode} ` : "",
      !!val?.country ? `(${val.country})` : "",
    ];
    const supplier = {
      ...val,
      address: addr.join(""),
      contact: val.contact,
      tel: val?.tel?.replace(/[^(0-9, \-, \s, \\,)]/g, "")?.trim(),
    };
    // console.log(val.contact)
    setFormDetail((state) => ({ ...state, ...supplier }));
    form.setFieldsValue({ ...fvalue, ...supplier });
    // setListDetail([]);
  };

  /* เลือกลูกค้า (กรณีรับของจากลูกค้า) — เก็บชื่อ/ที่อยู่/ผู้ติดต่อไว้ในหัวเอกสาร */
  const handleChoosedCustomer = (val) => {
    const fvalue = form.getFieldsValue();
    const addr = [
      val?.idno ? `${val.idno} ` : "",
      val?.road ? `${val.road} ` : "",
      val?.subdistrict ? `${val.subdistrict} ` : "",
      val?.district ? `${val.district} ` : "",
      val?.province ? `${val.province} ` : "",
      val?.zipcode ? `${val.zipcode} ` : "",
      val?.country ? `(${val.country})` : "",
    ].join("");

    const customer = {
      cuscode: val?.cuscode,
      cusname: val?.cusname,
      address: addr,
      contact: val?.contact,
      tel: val?.tel?.replace(/[^(0-9, \-, \s, \\,)]/g, "")?.trim(),
    };
    setFormDetail((state) => ({ ...state, ...customer }));
    form.setFieldsValue({ ...fvalue, ...customer });
  };

  const handleItemsChoosed = (value) => {
    const newData = [...value];
    newData.forEach((item, index) => {
      item.seq = index + 1;
      item.code = item?.code;
      item.qty = item?.qty || 1;
      item.qty_buy = Number(item?.qty_buy || 0);
      item.recamount = Number(item?.recamount || 0);
      item.stname = item?.stname;
      item.typename = item?.typename;
      item.price = Number(item?.price || 0);
      item.discount = Number(item?.discount || 0);
      item.stcode = item?.stcode;
      item.pocode = item?.pocode;
      item.unit = item?.unit || "ชิ้น";
      item.shelf_life = item?.shelf_life || 0;
      item.expire = [{
        seq: item?.seq || 1,
        stock_date: dayjs(form.getFieldValue("grdate")).format("YYYY-MM-DD"),
        /* ไม่เติมวันที่ให้อัตโนมัติ — ผู้ใช้กรอกวันที่ผลิต/วันหมดอายุเอง */
        mfg_date: null,
        expire_date: null,
        list_qty: item?.qty || 1,
      },];
    });

    // expire: [
    //     {
    //       seq: 1,
    //       expire_date: dayjs(new Date())
    //         .add(value.shelf_life, "day")
    //         .format("YYYY-MM-DD"),
    //       list_qty: value?.qty || 1,
    //     },
    //   ],

    setListDetail(newData);
    handleSummaryPrice();
    // console.log(value);
  };

  /* ===== AI DocScan : เติมข้อมูลจากใบส่งของที่อ่านด้วย AI (หน้า /ERP/goods-receipt/ai-scan) ===== */
  const aiPrefill = location.state?.aiPrefill;
  const aiPrefillDone = React.useRef(false);
  useEffect(() => {
    if (!aiPrefill || aiPrefillDone.current) return;
    if (config?.action !== "create" || !poCode) return;
    aiPrefillDone.current = true;
    /* รายการก่อน แล้วค่อยผู้ขาย — handleItemsChoosed คำนวณยอดจาก formDetail เดิม ถ้าเลือกผู้ขายก่อนจะถูกทับ */
    if (Array.isArray(aiPrefill.items) && aiPrefill.items.length) {
      handleItemsChoosed(aiPrefill.items.map(({ lots, ...it }) => ({ ...it })));
      const stockDate = dayjs(form.getFieldValue("grdate")).format("YYYY-MM-DD");
      setListDetail((prev) =>
        prev.map((it) => {
          const src = aiPrefill.items.find((x) => x.code === it.code);
          if (!src?.lots?.length) return it;
          /* ใช้วันที่ตามที่อ่านได้จากใบส่งของเท่านั้น ไม่คำนวณจากอายุสินค้า */
          return {
            ...it,
            expire: src.lots.map((l, i) => ({
              seq: i + 1,
              stock_date: stockDate,
              mfg_date: l.mfg_date || null,
              expire_date: l.expire_date || null,
              list_qty: Number(l.qty || 0),
            })),
          };
        })
      );
    }
    if (aiPrefill.supplier) handleChoosedSupplier(aiPrefill.supplier);
    form.setFieldsValue({
      inv_no: aiPrefill.inv_no || null,
      inv_date: aiPrefill.inv_date ? dayjs(aiPrefill.inv_date) : null,
      remark: aiPrefill.remark || form.getFieldValue("remark"),
    });
    message.info("เติมข้อมูลจากใบส่งของแล้ว กรุณาตรวจสอบก่อนบันทึก");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [poCode]);
  /* ===== /AI DocScan ===== */

  const handleConfirm = () => {
    form
      .validateFields()
      .then((v) => {
        if (listDetail.length < 1) throw new Error("กรุณาเพิ่ม รายการขาย");

        const invDate = form.getFieldValue("inv_date");
        const header = {
          ...formDetail,
          grdate: dayjs(form.getFieldValue("grdate")).format("YYYY-MM-DD"),
          /* เอกสารของผู้จำหน่าย : เว้นว่างได้ ส่ง null ไปแทนค่าว่าง */
          inv_no: (form.getFieldValue("inv_no") || "").trim() || null,
          inv_date: invDate ? dayjs(invDate).format("YYYY-MM-DD") : null,
          remark: form.getFieldValue("remark"),
          /* PO = รับตามใบสั่งซื้อ , CUSTOMER = รับของจากลูกค้า */
          source_type: sourceType,
          cuscode: isFromCustomer ? formDetail.cuscode || null : null,
          supcode: isFromCustomer ? null : formDetail.supcode || null,
        };
        const detail = listDetail;

        const parm = { header, detail };
        // console.log(parm)

        const actions =
          config?.action !== "create" ? grservice.update : grservice.create;
        actions(parm)
          .then((r) => {
            handleClose().then((r) => {
              message.success("Request GoodsReceipt success.");
            });
          })
          .catch((err) => {
            /* แสดงข้อความจริงจากเซิร์ฟเวอร์ จะได้รู้สาเหตุ เช่น คอลัมน์ยังไม่มีใน DB */
            const msg = err?.response?.data?.message;
            console.warn(err);
            Modal.error({
              title: "บันทึกไม่สำเร็จ",
              content: msg || "Request GoodsReceipt fail.",
            });
          });
      })
      .catch((err) => {
        /* validateFields ไม่ผ่าน — บอกด้วยว่าช่องไหน */
        const fields = (err?.errorFields || [])
          .map((f) => f.errors?.[0])
          .filter(Boolean);
        if (fields.length > 0) {
          Modal.error({
            title: "ข้อมูลยังไม่ครบถ้วน",
            content: fields.join(" / "),
          });
          return;
        }
        console.warn(err);
        Modal.error({
          title: "บันทึกไม่สำเร็จ",
          content: err?.message || "กรุณาตรวจสอบข้อมูลอีกครั้ง",
        });
      });
  };

  const handleClose = async () => {
    navigate(gotoFrom, { replace: true });
    await delay(300);
    // console.clear();
  };

  const handlePrint = () => {
    const newWindow = window.open("", "_blank");
    newWindow.location.href = `/quo-print/${formDetail.quotcode}`;
  };

  const handleDelete = (seq) => {
    const itemDetail = [...listDetail];
    const newData = itemDetail.filter((item) => item?.seq !== seq);
    setListDetail([...newData]);
  };

  const handleAction = (record) => {
    /* ตอนแก้ไข : ลบรายการไม่ได้ เพราะสต๊อกกับยอดรับของใน PO ลงไปแล้ว */
    if (config?.action !== "create") return null;

    const itemDetail = [...listDetail];
    return itemDetail.length >= 1 ? (
      <Button
        className="bt-icon"
        size="small"
        danger
        icon={
          <RiDeleteBin5Line style={{ fontSize: "1rem", marginTop: "3px" }} />
        }
        onClick={() => handleDelete(record?.seq)}
        disabled={!record?.seq}
      />
    ) : null;
  };

  /* ปรับรายการ lot (วันหมดอายุ) ให้ผลรวมเท่ากับ "จำนวนที่จะรับ" ที่แก้ใหม่ */
  const syncExpireWithQty = (item, newQty) => {
    const qty = Number(newQty || 0);
    const shelfLife = Number(item?.shelf_life || 0);
    const stockDate = dayjs(form.getFieldValue("grdate")).format("YYYY-MM-DD");
    const list = Array.isArray(item?.expire) ? [...item.expire] : [];

    // ยังไม่มี lot หรือมีก้อนเดียว → ตั้งจำนวนให้เท่ากับจำนวนที่จะรับเลย
    if (list.length <= 1) {
      const base = list[0] || {};
      /* วันที่ผลิตมาจากที่ผู้ใช้กรอก ไม่ตั้งเป็นวันนี้ให้
         คำนวณวันหมดอายุต่อเมื่อมีวันที่ผลิตแล้วเท่านั้น */
      const mfg = base.mfg_date || null;
      return [
        {
          ...base,
          seq: 1,
          stock_date: stockDate,
          mfg_date: mfg,
          expire_date:
            mfg && shelfLife > 0
              ? dayjs(mfg).add(shelfLife, "day").format("YYYY-MM-DD")
              : base.expire_date || null,
          list_qty: qty,
        },
      ];
    }

    // แยกหลาย lot → ไล่เติมตามลำดับเดิม ส่วนที่เกินให้ตัดทิ้ง ส่วนที่ขาดเติมที่ lot สุดท้าย
    let remain = qty;
    const out = [];
    for (const lot of list) {
      if (remain <= 0) break;
      const take = Math.min(Number(lot.list_qty || 0), remain);
      out.push({
        ...lot,
        seq: out.length + 1,
        stock_date: stockDate,
        list_qty: take,
      });
      remain -= take;
    }
    if (remain > 0 && out.length > 0) {
      const last = out[out.length - 1];
      out[out.length - 1] = {
        ...last,
        list_qty: Number(last.list_qty || 0) + remain,
      };
    }
    return out;
  };

  const handleSave = (row) => {
    const newData = (r) => {
      const newData = [...listDetail];
      const ind = newData.findIndex(
        (item) => r?.stcode === item?.stcode || r?.code === item?.code
      );
      if (ind < 0) return newData;
      const item = newData[ind];

      const patch = { ...r };
      // แก้ช่อง "จำนวนที่จะรับ" ในตาราง → ให้จำนวนในวันหมดอายุตามไปด้วย
      // ข้ามเมื่อมี expire ติดมาด้วย เพราะนั่นคือผลลัพธ์จากหน้าต่างแก้วันหมดอายุ
      // (ห้ามสร้าง lot ใหม่ทับของที่ผู้ใช้เพิ่งตั้งเอง)
      if (r?.key === "qty" && !Array.isArray(r?.expire)) {
        patch.expire = syncExpireWithQty({ ...item, ...r }, r.qty);
      }

      newData.splice(ind, 1, { ...item, ...patch });
      handleSummaryPrice();
      return newData;
    };
    setListDetail([...newData(row)]);
  };

  const handleAdjust = (value) => {
    // console.log(value);
    let adjustdata = {
      ...value,      
    };
    
    setFormPO(adjustdata);
    setOpenExpiryDate(true);

    // expire: [
    //     {
    //       seq: 1,
    //       expire_date: dayjs(new Date())
    //         .add(value.shelf_life, "day")
    //         .format("YYYY-MM-DD"),
    //       list_qty: value?.qty || 1,
    //     },
    //   ],
  };

  const handleReceivedStock = (record) => {
    handleSave(record);
    setFormPO({});
    setOpenExpiryDate(false);
  };

  /** setting column table
   *  แก้ไขใบรับสินค้า = แก้ได้เฉพาะหัวเอกสาร รายการสินค้าล็อกทั้งหมด */
  const isCreate = config?.action === "create";
  const prodcolumns = columnsParametersEditable(handleSave, unitOption, {
    handleAction,
    handleAdjust,
    readOnly: !isCreate,
  });

  const adjust_action = (
    <Row
      gutter={[{ xs: 32, sm: 32, md: 32, lg: 12, xl: 12 }, 8]}
      className="m-0"
    >
      <Col span={12} className="p-0">
        <Flex gap={4} justify="start">
          <Button
            form="shippingtype-form"
            htmlType="submit"
            icon={<TbSquareRoundedChevronsLeft style={{ fontSize: "1rem" }} />}
            className="bn-center bn-danger-outline"
            style={{ width: "9.5rem" }}
            onClick={() => setOpenExpiryDate(false)}
          >
            ปิด
          </Button>
        </Flex>
      </Col>
      <Col span={12} className="p-0">
        <Flex gap={4} justify="end">
          <Button
            form="form-product-expiry"
            htmlType="submit"
            icon={<TbSquareRoundedCheck style={{ fontSize: "1rem" }} />}
            className="bn-center bn-primary-outline"
            style={{ width: "9.5rem" }}
          >
            ยืนยัน
          </Button>
        </Flex>
      </Col>
    </Row>
  );

  const SectionSupplier = (
    <>
      <Space size="small" direction="vertical" className="flex gap-2">
        <Row gutter={[8, 8]} className="m-0">
          {/* รับตามใบสั่งซื้อ หรือรับของจากลูกค้าโดยไม่มีใบสั่งซื้อ */}
          <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24}>
            <Form.Item label="ประเภทการรับ" className="!mb-1">
              <Segmented
                value={sourceType}
                disabled={config?.action !== "create"}
                onChange={(v) => {
                  setSourceType(v);
                  setListDetail([]);
                  const clear = {
                    supcode: null,
                    supname: null,
                    cuscode: null,
                    cusname: null,
                    address: null,
                    contact: null,
                    tel: null,
                  };
                  setFormDetail((st) => ({ ...st, ...clear }));
                  form.setFieldsValue(clear);
                }}
                options={[
                  { label: "รับตามใบสั่งซื้อ (ผู้ขาย)", value: "PO" },
                  { label: "รับของจากลูกค้า (ไม่มีใบสั่งซื้อ)", value: "CUSTOMER" },
                ]}
              />
            </Form.Item>
          </Col>

          {isFromCustomer ? (
            <>
              <Col xs={24} sm={24} md={12} lg={12} xl={12} xxl={12}>
                <Form.Item
                  name="cuscode"
                  label="รหัสลูกค้า"
                  className="!mb-1"
                  rules={[{ required: true, message: "กรุณาเลือกลูกค้า" }]}
                >
                  <Space.Compact style={{ width: "100%" }}>
                    <Input
                      readOnly
                      placeholder="เลือก ลูกค้า"
                      value={formDetail.cuscode}
                      className="!bg-white"
                    />
                    <Button
                      type="primary"
                      icon={<SearchOutlined />}
                      onClick={() => setOpenCustomer(true)}
                      disabled={config?.action !== "create"}
                      style={{ minWidth: 40 }}
                    />
                  </Space.Compact>
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12} lg={12} xl={12} xxl={12}>
                <Form.Item name="cusname" label="ชื่อลูกค้า" className="!mb-1">
                  <Input placeholder="ชื่อลูกค้า" readOnly />
                </Form.Item>
              </Col>
            </>
          ) : (
          <>
          <Col xs={24} sm={24} md={12} lg={12} xl={12} xxl={12}>
            <Form.Item
              name="supcode"
              htmlFor="supcode-1"
              label="รหัสผู้ขาย"
              className="!mb-1"
              rules={[{ required: true, message: "กรอกรหัสผู้ขาย" }]}
            >
              <Space.Compact style={{ width: "100%" }}>
                <Input
                  readOnly
                  placeholder="เลือก ผู้ขาย"
                  id="supcode-1"
                  value={formDetail.supcode}
                  className="!bg-white"
                />
                {/* ตอนแก้ไข : เปลี่ยนผู้ขายไม่ได้ รายการสินค้าผูกกับ PO ของรายเดิมอยู่ */}
                <Button
                  type="primary"
                  icon={<SearchOutlined />}
                  onClick={() => setOpenSupplier(true)}
                  disabled={config?.action !== "create"}
                  style={{ minWidth: 40 }}
                ></Button>
              </Space.Compact>
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={12} lg={12} xl={12} xxl={12}>
            <Form.Item name="supname" label="ชื่อผู้ขาย" className="!mb-1">
              <Input placeholder="ชื่อผู้ขาย." readOnly />
            </Form.Item>
          </Col>
          </>
          )}
          <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24}>
            <Form.Item name="address" label="ที่อยู่ผู้ขาย" className="!mb-1">
              <Input placeholder="ที่อยู่ผู้ขาย" readOnly />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={12} lg={12} xl={12} xxl={12}>
            <Form.Item name="contact" label="ติดต่อ" className="!mb-1">
              <Input placeholder="ติดต่อ" readOnly />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={12} lg={12} xl={12} xxl={12}>
            <Form.Item name="tel" label="เบอร์" className="!mb-1">
              <Input placeholder="เบอร์" readOnly />
            </Form.Item>
          </Col>
          {/* เอกสารของผู้จำหน่ายที่แนบมากับของ — พิมพ์ออกในฟอร์มบันทึกรับเข้า */}
          <Col xs={24} sm={24} md={12} lg={12} xl={12} xxl={12}>
            <Form.Item name="inv_no" label="เลขที่ Inv/ใบส่งของ" className="!mb-1">
              <Input placeholder="เลขที่ใบกำกับ/ใบส่งของจากผู้ขาย" />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={12} lg={12} xl={12} xxl={12}>
            <Form.Item name="inv_date" label="วันที่ Inv/ใบส่งของ" className="!mb-1">
              {/* input-40 = สูง 40px เท่าช่องข้อความอื่นในฟอร์ม */}
              <DatePicker
                className="input-40 width-100"
                format={dateFormat}
                placeholder="เลือกวันที่"
              />
            </Form.Item>
          </Col>
        </Row>
        {/* <Row gutter={[8, 8]} className="m-0">
        <Col xs={24} sm={24} md={12} lg={12} xl={12} xxl={12}>
            <Form.Item name="tel" label="วันที่นัดส่งของ" className="!mb-1">
              <Input placeholder="วันที่นัดส่งของ." readOnly />
            </Form.Item>
          </Col>
        </Row> */}
      </Space>
    </>
  );

  const TitleTable = (
    <Flex className="width-100" align="center">
      <Col span={12} className="p-0">
        <Flex gap={8} justify="start" align="center" wrap="wrap">
          <Typography.Title className="m-0 !text-zinc-800" level={3}>
            รายการสินค้า
          </Typography.Title>
          {/* บอกเหตุผลที่แก้รายการไม่ได้ กันผู้ใช้สงสัยว่าระบบเสีย */}
          {config?.action !== "create" && (
            <Typography.Text type="secondary" style={{ fontSize: 12 }}>
              แก้ไขได้เฉพาะหัวเอกสาร — รายการสินค้าลงสต๊อกและตัดยอดใบสั่งซื้อไปแล้ว
              ถ้าจำนวนหรือรายการผิด ให้ยกเลิกใบนี้แล้วออกใบใหม่
            </Typography.Text>
          )}
        </Flex>
      </Col>
      <Col span={12} style={{ paddingInline: 0 }}>
        <Flex justify="end">
          <Button
            icon={<LuPackageSearch style={{ fontSize: "1.2rem" }} />}
            className="bn-center justify-center bn-primary-outline"
            onClick={() => {
              /* รับจากลูกค้า = เลือกสินค้าเองจากทะเบียน ไม่ต้องมีใบสั่งซื้อ */
              if (isFromCustomer) setOpenFreeItems(true);
              else setOpenProduct(true);
            }}
            disabled={config?.action !== "create"}
          >
            {isFromCustomer ? "เลือกสินค้า" : "เลือกใบสั่งซื้อ"}
          </Button>
        </Flex>
      </Col>
    </Flex>
  );

  const SectionProduct = (
    <>
      <Flex className="width-100" vertical gap={4}>
        <Table
          title={() => TitleTable}
          components={componentsEditable}
          rowClassName={() => "editable-row"}
          bordered
          dataSource={listDetail}
          columns={prodcolumns}
          pagination={false}
          rowKey="stcode"
          scroll={{ x: "max-content" }}
          locale={{
            emptyText: <span>No data available, please add some data.</span>,
          }}
        />
      </Flex>
    </>
  );

  const SectionOther = (
    <>
      <Space size="small" direction="vertical" className="flex gap-2">
        <Row gutter={[8, 8]} className="m-0">
          <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24}>
            <Form.Item className="" name="remark" label="Remark">
              <Input.TextArea placeholder="Enter Remark" rows={4} />
            </Form.Item>
          </Col>
        </Row>
      </Space>
    </>
  );

  ///** button */

  const SectionTop = (
    <Row
      gutter={[{ xs: 32, sm: 32, md: 32, lg: 12, xl: 12 }, 8]}
      className="m-0"
    >
      <Col span={12} className="p-0">
        <Flex gap={4} justify="start">
          <ButtonBack target={gotoFrom} />
        </Flex>
      </Col>
      <Col span={12} style={{ paddingInline: 0 }}>
        <Flex gap={4} justify="end">
          <ActionGroup type="print">
            {!!formDetail.quotcode && (
              <PrintButton icon={<LuPrinter />} onClick={() => handlePrint()}>
                PRINT QUOTATION
              </PrintButton>
            )}
          </ActionGroup>
        </Flex>
      </Col>
    </Row>
  );

  const SectionBottom = (
    <Row
      gutter={[{ xs: 32, sm: 32, md: 32, lg: 12, xl: 12 }, 8]}
      className="m-0"
    >
      <Col span={12} className="p-0">
        <Flex gap={4} justify="start">
          <ButtonBack target={gotoFrom} />
        </Flex>
      </Col>
      <Col span={12} style={{ paddingInline: 0 }}>
        <Flex gap={4} justify="end">
          <Button
            className="bn-center justify-center"
            icon={<SaveFilled style={{ fontSize: "1rem" }} />}
            type="primary"
            style={{ width: "9.5rem" }}
            onClick={() => {
              handleConfirm();
            }}
          >
            Save
          </Button>
        </Flex>
      </Col>
    </Row>
  );

  return (
    <div className="goodsreceipt-manage">
      <div id="goodsreceipt-manage" className="px-0 sm:px-0 md:px-8 lg:px-8">
        <Space direction="vertical" className="flex gap-4">
          {SectionTop}
          <Form
            form={form}
            layout="vertical"
            className="width-100"
            autoComplete="off"
          >
            <Card
              title={
                <>
                  <Row className="m-0 py-3 sm:py-0" gutter={[12, 12]}>
                    <Col xs={24} sm={24} md={12} lg={12} xl={12} xxl={12}>
                      <Typography.Title level={3} className="m-0">
                        รหัสใบรับสินค้า : {poCode}
                      </Typography.Title>
                    </Col>
                    <Col xs={24} sm={24} md={12} lg={12} xl={12} xxl={12}>
                      <Flex
                        gap={10}
                        align="center"
                        className="justify-start sm:justify-end"
                      >
                        <Typography.Title level={3} className="m-0">
                          วันที่ใบรับสินค้า :{" "}
                        </Typography.Title>
                        <Form.Item name="grdate" className="!m-0">
                          <DatePicker
                            className="input-40"
                            allowClear={false}
                            onChange={handleQuotDate}
                            format={dateFormat}
                          />
                        </Form.Item>
                      </Flex>
                    </Col>
                  </Row>
                </>
              }
            >
              <Row className="m-0" gutter={[12, 12]}>
                <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24}>
                  <Divider orientation="left" className="!mb-3 !mt-1">
                    {" "}
                    ผู้ขาย{" "}
                  </Divider>
                  <Card style={cardStyle}>{SectionSupplier}</Card>
                </Col>
                <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24}>
                  <Divider orientation="left" className="!mb-3 !mt-1">
                    {" "}
                    ข้อมูลเพิ่มเติม{" "}
                  </Divider>
                  <Card style={cardStyle}>{SectionOther}</Card>
                </Col>
                <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24}>
                  <Divider orientation="left" className="!my-0">
                    รายการใบสั่งซื้อสินค้า
                  </Divider>
                  <Card style={{ backgroundColor: "#f0f0f0" }}>
                    {SectionProduct}
                  </Card>
                </Col>
              </Row>
            </Card>
          </Form>
          {SectionBottom}
        </Space>
      </div>

      {openSupplier && (
        <ModalSupplier
          show={openSupplier}
          close={() => setOpenSupplier(false)}
          values={(v) => {
            handleChoosedSupplier(v);
          }}
          parm={config?.action === "create" ? { pending: 1 } : {}}
        ></ModalSupplier>
      )}

      {openCustomer && (
        <ModalCustomers
          show={openCustomer}
          close={() => setOpenCustomer(false)}
          values={(v) => handleChoosedCustomer(v)}
          selected={[]}
        />
      )}

      {openFreeItems && (
        <ModalGrItems
          show={openFreeItems}
          close={() => setOpenFreeItems(false)}
          values={(v) => handleItemsChoosed(v)}
          selected={listDetail}
        />
      )}

      {openProduct && (
        <ModalItems
          show={openProduct}
          close={() => setOpenProduct(false)}
          values={(v) => {
            handleItemsChoosed(v);
          }}
          selected={listDetail}
          supcode={formDetail.supcode}
        ></ModalItems>
      )}
      <Drawer
        title={
          <Flex align="center" gap={4}>
            แก้วันหมดอายุ <EditOutlined style={{ fontSize: "1.2rem" }} />
          </Flex>
        }
        onClose={() => setOpenExpiryDate(false)}
        open={openExpiryDate}
        footer={adjust_action}
        width={1100}
        className="responsive-drawer"
        styles={{
          body: drawerBodyStyle,
        }}
      >
        {openExpiryDate && (
          <ManageFormExpiryDate data={formPO} submit={handleReceivedStock} />
        )}
      </Drawer>
    </div>
  );
}

export default GoodsReceiptManage;
